const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.HorseExamRequirementServiceSimpleClient =
  function HorseExamRequirementServiceSimpleClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listHorseExamRequirements = this.listHorseExamRequirements.bind(this);
    this.confirmExamRequirementReadiness =
      this.confirmExamRequirementReadiness.bind(this);
  };
const methodInfo_HorseExamRequirementService_ListHorseExamRequirements =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamRequirementService/ListHorseExamRequirements",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest,
    imports.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse.decode
  );
module.exports.HorseExamRequirementServiceSimpleClient.prototype.listHorseExamRequirements =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamRequirementService/ListHorseExamRequirements",
      message,
      metadata || {},
      methodInfo_HorseExamRequirementService_ListHorseExamRequirements
    );
  };
const methodInfo_HorseExamRequirementService_ConfirmExamRequirementReadiness =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamRequirementService/ConfirmExamRequirementReadiness",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest,
    imports.stronachgroup.first.racehorse360.HorseExamRequirement,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseExamRequirement.decode
  );
module.exports.HorseExamRequirementServiceSimpleClient.prototype.confirmExamRequirementReadiness =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamRequirementService/ConfirmExamRequirementReadiness",
      message,
      metadata || {},
      methodInfo_HorseExamRequirementService_ConfirmExamRequirementReadiness
    );
  };
